<template>
  <div class="home">
    <div class="p-relative">
      <heading class="mt-10 z-index-2 p-relative" />
      <tvl-chart />
    </div>
    <product-overview />
  </div>
</template>

<script>
import Heading from "./Heading";
import TvlChart from "./TvlChart";
import ProductOverview from "./ProductOverview";

export default {
  components: {
    Heading,
    TvlChart,
    ProductOverview,
  },
  methods: {
    loadData() {
      this.$store.dispatch("productStats/fetchVaultsStats");
      this.$store.dispatch("productStats/fetchStakeStats");
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>
